import { render, staticRenderFns } from "./subjectAnswer.vue?vue&type=template&id=11880a3d&scoped=true"
import script from "./subjectAnswer.vue?vue&type=script&lang=js"
export * from "./subjectAnswer.vue?vue&type=script&lang=js"
import style0 from "./subjectAnswer.vue?vue&type=style&index=0&id=11880a3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11880a3d",
  null
  
)

export default component.exports